import { ActionItemInterface } from './action-item.interface';

export class ActionItem implements ActionItemInterface {
  id: number = 0;
  label: string = '';
  visible: boolean = false;
  allow: boolean = false;
  icon: string = '';
  rotate?: number = 0;
  message?: string = '';
}
